import React from 'react'
import { Box, CircularProgress } from '@mui/material'
import { mainGreen } from '../utils/color'

export default function Loading() {
	return (
		<Box sx={{ marginTop: '120px', display: 'flex', justifyContent: 'center' }}>
			<CircularProgress sx={{ color: mainGreen }} />
		</Box>
	)
}
